export const yDocFragment = 'default'
